var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth side side-blank"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.$t('base.idicare.slogan_1')))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t('base.idicare.slogan_2')))])]),_vm._v(" "),_c('auth-static-content-links'),_vm._v(" "),_c('locale-flag-selector')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f67fedf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SideBlank.vue
// module id = null
// module chunks = 